import gql from 'graphql-tag';

export const getCustomerInfo = gql`
  query ($customerId: Int) {
    getCustomerInfo(customerId: $customerId) {
      customerId
      identifier
      phone
      email
      remark
      date
      os
		  attendances {
        beacon {
          zone
        }
        checkIn
        checkOut
      }
      advertisementTokens {
        referrals
        views
        date
        minisite {
          minisiteId
          title
        }
      }
      couponTokens {
        ticks
        redeems
        date
        minisite {
          minisiteId
          title
        }
      }
      pollingTokens {
        views
        pollingDate
        minisite {
          minisiteId
          title
        }
        pollingAnswers {
          pollingQuestion {
            question
          }
          choices
          openText
          rating
        }
      }
      votingTokens {
        views
        votingDate
        minisite {
          minisiteId
          title
        }
        votingAnswers {
          votingQuestion {
            question
          }
          choices
        }
      }
      deepLinkTokens {
        referrals
        views
        minisite {
          minisiteId
          title
        }
      }
      sessionLogs {
        minisite {
          minisiteId
          title
        }
        beacon {
          deviceId
          latitude
          longitude
        }
      }
    }
  }
`
